var Presse = {

    isMoving:false,
    mouseX:0,
    mouseY:0,
    timeoutResize:0,

    init:function(){
        $(window).resize(function(){
            Presse.resize();
        });

        Presse.resize();

        if(Config.isTouchDevice()){
            $(".rollover-presse-container").addClass("mobile");
        }

        $(window).mousemove(function(event){
            Presse.mouseX = event.pageX;
            Presse.mouseY = event.pageY;
        });

        $(".liste-presse .tease-presse").find(".illustration").mouseenter(function(){

            $(".rollover-presse-container").addClass("visible");

            Presse.isMoving = true;
            Presse.moveRollover();
        }).mouseleave(function(){
            Presse.isMoving = false;

            /*$(this).find("img").css({width:$(this).find("img").attr("out_w"), height:$(this).find("img").attr("out_h")});*/
            $(".rollover-presse-container").removeClass("visible");
        });
    },
    moveRollover:function(){

        $(".rollover-presse-container").css({left:Presse.mouseX, top:Presse.mouseY});

        if(Presse.isMoving == true){
            setTimeout(function(){
                Presse.moveRollover();
            }, 40);
        }
    },
    resize:function(){

        $(".liste-presse .arrow-container").css({height:$(".liste-presse .illustration").outerHeight()});

        var _carousel = $(".liste-presse .slick-container");

        if (_carousel.hasClass('slick-initialized')) {
            _carousel.slick('unslick');
        }

        //var _slides_to_show = parseInt($("[slider-3-columns]").css("padding-top"));

        var _slides_to_show = 1;
        var els = document.querySelectorAll(".liste-presse");

        Array.prototype.forEach.call(els, function(el) {
            _slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
        });

        _carousel.slick({
            arrows:true,
            dots:false,
            infinite: true,
            variableWidth:true,
            slidesToShow: _slides_to_show,
            focusOnSelect: true,
            touchThreshold:500,
            prevArrow:$(".liste-presse .arrow-container.prev .arrow"),
            nextArrow:$(".liste-presse .arrow-container.next .arrow")
        });
    }
}
$(window).load(function(){
    if($(".liste-presse").length){
        Presse.init();
    }
})